<template>
  <ul class="job-referral-info-list">
    <li v-for="(info, index) in infoList" class="referral-item" :class="[info.length > 1 && 'has-more']" :key="index">
      <div v-if="isInLine" class="referral-info">
        <div class="referral-title">{{ info[0].text }}</div>
        <div v-if="info.length > 1" class="referral-tip">{{ `(${info[1].text})` }}</div>
      </div>
      <div v-else class="referral-info">
        <p class="referral-title" :class="info[0].class">{{ info[0].text }}</p>
        <p v-if="info.length > 1" class="referral-tip">{{ `(${info[1].text})` }}</p>
      </div>
    </li>
  </ul>
</template>

<script>
import _ from 'lodash'

const stepDataKey = {
  apply: 'applied_budget',
  interview: 'interviewed_budget',
  onboard: 'onboard_budget',
  probation: 'probation_budget'
}

const hireTypeDataKey = {
  employee: 'ee',
  notEmployee: 'non_ee'
}

const rewardTypeDataKey = {
  points: 'points',
  cash: 'cash',
  payroll: 'payroll'
}

function getOriginStepDataKey (stepDataKey) {
  return stepDataKey.replace(/_budget/, '')
}

export default {
  props: {
    isInLine: {
      type: Boolean,
      default: false
    },
    isFosunCompany: {
      type: Boolean,
      required: true
    },
    isCompanyEmployee: {
      type: Boolean,
      required: true
    },
    hasCustomReferralWord: {
      type: Boolean,
      required: true
    },
    usePointsReplaceOthers: {
      type: Boolean,
      default: false
    },
    stepSetting: {
      required: true
    },
    isADPCompany: {
      type: Boolean,
      default: false
    },
    isCoachCompany: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    infoList () {
      const info = []
      const hireDataKey = this.isCompanyEmployee ? hireTypeDataKey.employee : hireTypeDataKey.notEmployee
      const needTipStep = [stepDataKey.apply, stepDataKey.interview]
      if (this.isADPCompany) {
        info.push(
          [{ text: this.$t('jobDetail.label.reward.points', { reward: 200 }) }],
          [{ text: this.$t('jobDetail.ADPReferralTipMessage') }]
        )
      } else {
        _.forEach(stepDataKey, (stepKey, stepName) => {
          const stepSetting = this.stepSetting[stepKey]
          const hireSetting = stepSetting[hireDataKey]
          const { text: rewardText } = this.getRewardText(hireSetting)
          if (rewardText) {
            const childInfo = []
            if (stepKey === stepDataKey.probation && (this.isFosunCompany || this.hasCustomReferralWord)) {
              if (this.hasCustomReferralWord) {
                childInfo.push(
                  { text: this.$t('jobDetail.referralBonus'), class: 'reward' },
                  { text: this.$t('jobDetail.accordingToEmployee') }
                )
              } else {
                childInfo.push(
                  { text: this.$t('jobDetail.uponSuccessfulReferral'), class: 'reward' },
                  { text: this.$t('jobDetail.referralBonusesDesc') }
                )
              }
            } else {
              const stepLabel = this.$t(`jobDetail.label.step.${stepName}`)
              childInfo.push({ text: `${stepLabel} - ${rewardText}`, class: 'reward' })
            }
            if (needTipStep.includes(stepKey) && !this.isCoachCompany) {
              const originStepKey = getOriginStepDataKey(stepKey)
              const topReferrerCount = this.stepSetting[originStepKey][hireDataKey].count
              childInfo.push({ text: this.$t('jobDetail.label.topReferrer', { count: topReferrerCount }) })
            }
            if (stepKey === stepDataKey.onboard || stepKey === stepDataKey.probation) {
              childInfo.push({ text: this.$t('jobDetail.label.finalReward') })
            }
            info.push(childInfo)
          }
        })
      }
      return info
    }
  },
  created () {

  },
  methods: {
    getRewardText (config) {
      let text = null
      const rewardType = null
      _.forEach(rewardTypeDataKey, (dataKey, typeName) => {
        const reward = parseInt(config[dataKey])
        if (reward > 0) {
          let rewardType = typeName
          if (this.usePointsReplaceOthers) {
            rewardType = 'points'
          }
          text = this.$t(`jobDetail.label.referrerReward.${rewardType}`, { reward: this.formatBigAmount(reward) })
          rewardType = typeName
          return false
        }
      })
      return { text, rewardType }
    },
    formatBigAmount (amount) {
      return _.replace(amount, /\d{1,3}(?=(\d{3})+$)/g, function (s) { return s + ',' })
    }
  }
}
</script>

<style lang="scss" scoped>
.job-referral-info-list {
  list-style: disc;
  .referral-info {
    p {
      margin: 0;
      padding: 0;
    }
  }
}
</style>
